module.exports = ["adesso",["%s secondo fa","%s secondi fa"],["%s minuto fa","%s minuti fa"],["%s ora fa","%s ore fa"],["%s giorno fa","%s giorni fa"],["%s settimana fa","%s settimane fa"],["%s mese fa","%s mesi fa"],["%s anno fa","%s anni fa"]]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/it-IT.json
// module id = Lhui
// module chunks = 1